import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddressService } from '../services/address.service';
import { ActivatedRoute } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MapComponent } from "../../../shared/components/map/map.component";
import { LoaderService } from '../../../shared/services/loader.service';
import { codigoPostalValidator } from '../add-direccion/codigo-postal.validators';

@Component({
  selector: 'app-update-direccion',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MapComponent
  ],
  templateUrl: './update-direccion.component.html',
  styleUrls: ['./update-direccion.component.scss']
})
export class UpdateDireccionComponent implements OnInit {
  direccionForm!: FormGroup;
    buscarDireccionControl = new FormControl('', [
    Validators.minLength(8) // mínimo 8 caracteres 
  ]);
  catalogoCiudades: any[] = [];
  catalogoMunicipios: any[] = [];
  selectedCiudad: { id: string, descripcion: string } | null = null;
  public ciudadIdSeleccionada: string = '';
  public municipioIdSeleccionado: string = '';
  public ciudadDescripcionSeleccionada: string = '';
  public estadoDescripcionSeleccionado: string = '';
  selectedMunicipio: { id: string, descripcion: string } | null = null;
  
  latitud: number | null = null;
  longitud: number | null = null;
  
  estadoSeleccionado: any = null;
  estadoEncontradoId: string = '';
  idAddress: number | null = null;
  isLoading: boolean = true;

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar,
    private addressService: AddressService,
    private route: ActivatedRoute,
    private loading: LoaderService
  ) {}

  ngOnInit() {
    console.log('=== UPDATE-DIRECCION: Inicializando componente ===');
    
    this.isLoading = true;
    this.loading.show();
    
    this.direccionForm = this.fb.group({
      identificador: ['', Validators.required],
      calleNumero: ['', Validators.required],
      interior: [''],
      codigoPostal: ['', [Validators.required, codigoPostalValidator()]],
      colonia: ['', Validators.required],
      ciudad: ['', Validators.required],
      municipio: ['', Validators.required]
    });

    this.consultarCatalogo();
    
    const direccionStr = sessionStorage.getItem('direccionParaEditar');
    console.log('Datos de sessionStorage (direccionParaEditar):', direccionStr);
    
    if (direccionStr) {
      const direccion = JSON.parse(direccionStr);
      console.log('Dirección parseada para editar:', direccion);
      
      this.idAddress = direccion.idAddress ?? null;
      console.log('ID de dirección asignado:', this.idAddress);
      
      this.direccionForm.patchValue({
        identificador: direccion.identifier || '',
        calleNumero: direccion.streetNumber || '',
        interior: direccion.interiorDepartament || '',
        codigoPostal: direccion.cp || '',
        colonia: direccion.colony || '',
        ciudad: direccion.state || '',
        municipio: direccion.codemun || ''
      });
      
      this.latitud = direccion.lat ? parseFloat(direccion.lat) : null;
      this.longitud = direccion.lng ? parseFloat(direccion.lng) : null;
      
      console.log('Formulario inicializado con valores:', this.direccionForm.value);
      console.log('Coordenadas iniciales - Lat:', this.latitud, 'Lng:', this.longitud);
      
      // El match de colony se hará después de cargar el catálogo
    } else {
      console.log('No se encontraron datos de dirección en sessionStorage');
    }
  }

  consultarCatalogo() {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;
    const account = localStorage.getItem('account');

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 21,
        parametros: [
          {
            clCuenta: account
          }
        ]
      }
    };

    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoCiudades = response.catalogo;
        localStorage.setItem('catalogoCiudades', JSON.stringify(this.catalogoCiudades));
        
        // Hacer match completo dentro del loader
        const direccionStr = sessionStorage.getItem('direccionParaEditar');
        if (direccionStr) {
          const direccion = JSON.parse(direccionStr);
          
          // Match de state
          console.log('=== MATCH STATE CON CATÁLOGO ===');
          console.log('State a buscar:', direccion.state);
          
          const estadoEncontrado = this.catalogoCiudades.find((item: any) => {
            return item.descripcion === direccion.state;
          });
          
          if (estadoEncontrado) {
            console.log('Estado encontrado por state:', estadoEncontrado);
            this.selectedCiudad = estadoEncontrado;
            this.ciudadIdSeleccionada = estadoEncontrado.id;
            this.direccionForm.patchValue({
              ciudad: estadoEncontrado.id
            });
            
            // Cargar municipios inmediatamente
            this.loadMunicipiosInLoader(estadoEncontrado.id, direccion.municipality);
          } else {
            console.log('No se encontró match para state:', direccion.state);
            this.isLoading = false;
            this.loading.hide();
          }
        } else {
          this.isLoading = false;
          this.loading.hide();
        }
      },
      error: (error) => {
        console.error('Error al consultar catálogo de ciudades:', error);
        this.isLoading = false;
        this.loading.hide();
      }
    });
  }

  loadMunicipiosInLoader(estadoId: string, municipality: string) {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/catalog`;

    const headers = new HttpHeaders({
      'Authorization': token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    const body = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        idCatalogo: 41,
        parametros: [
          {
            codEnt: estadoId
          }
        ]
      }
    };
    
    this.http.post(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.catalogoMunicipios = response.catalogo;
        localStorage.setItem('catalogoMunicipios', JSON.stringify(this.catalogoMunicipios));
        
        // Match de municipality
        console.log('=== MATCH MUNICIPALITY CON CATÁLOGO ===');
        console.log('Municipality a buscar:', municipality);
        
        const municipioEncontrado = this.catalogoMunicipios.find((item: any) => {
          return item.descripcion === municipality;
        });
        
        if (municipioEncontrado) {
          console.log('Municipio encontrado por municipality:', municipioEncontrado);
          this.selectedMunicipio = municipioEncontrado;
          this.municipioIdSeleccionado = municipioEncontrado.id;
          this.direccionForm.patchValue({
            municipio: municipioEncontrado.id
          });
        } else {
          console.log('No se encontró match para municipality:', municipality);
        }
        
        this.isLoading = false;
        this.loading.hide();
      },
      error: (error) => {
        console.error('Error al consultar catálogo de municipios:', error);
        this.isLoading = false;
        this.loading.hide();
      }
    });
  }



  obtenerMunicipios(address: any) {
    // Verificar si el catálogo está cargado
    if (!this.catalogoCiudades || this.catalogoCiudades.length === 0) {
      console.warn('Catálogo no cargado para municipios. Reintentando en 1 segundo...');
      setTimeout(() => {
        this.obtenerMunicipios(address);
      }, 1000);
      return;
    }
    
    const codificadoPorpin = address?.address 
    
    let estado = '';
     if(codificadoPorpin){
      const estadoEncontrado = this.syncAddresSatateWithCatalogs(address);
      estado = estadoEncontrado?.id || this.ciudadIdSeleccionada;
    }else{
      estado = this.ciudadIdSeleccionada;
    }
    
    // Si no hay estado válido, no continuar
    if(!estado) {
      console.warn('No se pudo determinar el estado para obtener municipios');
      return;
    }
      const token = localStorage.getItem('accessToken') || '';
      const cognitoId = localStorage.getItem('cognito') || '';
      const url = `${this.baseUrl}/user/${cognitoId}/catalog`;

      const headers = new HttpHeaders({
        'Authorization': token,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      });

      const body = {
        identifier: {
          tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
          app: 'PortalAsistencia'
        },
        petition: {
          idCatalogo: 41,
          parametros: [
            {
              codEnt: estado
            }
          ]
        }
      };
      
      this.http.post(url, body, { headers }).subscribe({
        next: (response: any) => {
            this.catalogoMunicipios = response.catalogo;
            //merge con catalogo de municipios
              const municipioEncontrado =this.syncAddresMunicipioWithCatalogs(address);
          
            localStorage.setItem('catalogoMunicipios', JSON.stringify(this.catalogoMunicipios));
            },
        error: (error) => {
          console.error('Error al consultar catálogo de municipios:', error);
        }
      });
    
  }


syncAddresMunicipioWithCatalogs(address: any){
  const adrressPorpin = address?.address 
  if(adrressPorpin){
    const MunicipioDeseMapa = this.normalizeEstado(address.address.borough || address.address.county || '');

    const municipioEncontrado = this.catalogoMunicipios.find((item: any) => {
    return this.normalizeEstado(item.descripcion) === MunicipioDeseMapa;});
      
    if (municipioEncontrado) {
      this.selectedMunicipio = municipioEncontrado;
      this.direccionForm.patchValue({
        municipio: municipioEncontrado.id
      });
    }
    return municipioEncontrado;
  }else{
    return null;
  }
}


  syncAddresSatateWithCatalogs(address: any){
    console.log("Haciendo merge de estados " + JSON.stringify(address, null, 2));

    // Verificar si el catálogo está cargado
    if (!this.catalogoCiudades || this.catalogoCiudades.length === 0) {
      console.warn('Catálogo de ciudades no cargado aún. Reintentando en 1 segundo...');
      setTimeout(() => {
        this.syncAddresSatateWithCatalogs(address);
      }, 1000);
      return null;
    }

    const estadoOriginal = address.address.state || '';
    let estadoDesdeMapa = this.normalizeEstado(estadoOriginal);
    
    // Caso especial: si viene "ESTADO DE MEXICO", cambiarlo a "MEXICO"
    if (estadoDesdeMapa === 'ESTADO DE MEXICO') {
      estadoDesdeMapa = 'MEXICO';
    }
    
    console.log('Estado original:', estadoOriginal);
    console.log('Estado desde mapa normalizado:', estadoDesdeMapa);
    console.log('Estados en catálogo:', this.catalogoCiudades.map(c => this.normalizeEstado(c.descripcion)));

    // Hacer merge con catalogoCiudades (que son los estados)
    const estadoEncontrado = this.catalogoCiudades.find((item: any) => {
      const descripcionNormalizada = this.normalizeEstado(item.descripcion);
      console.log(`Comparando: "${descripcionNormalizada}" === "${estadoDesdeMapa}"`);
      return descripcionNormalizada === estadoDesdeMapa;
    });

    if (estadoEncontrado) {
      this.selectedCiudad = estadoEncontrado;
      this.ciudadIdSeleccionada = estadoEncontrado.id;
      this.ciudadDescripcionSeleccionada = estadoEncontrado.descripcion;
      this.estadoEncontradoId = estadoEncontrado.id;
      this.estadoDescripcionSeleccionado = estadoEncontrado.descripcion;

      if(this.estadoEncontradoId){
        this.direccionForm.patchValue({
          ciudad: this.ciudadIdSeleccionada
        });
      }
    } else {
      console.warn('No se encontró el estado en el catálogo:', estadoDesdeMapa);
    }
    return estadoEncontrado;
  }

  normalizeEstado(estado: string): string {
    if (!estado) return '';
    
    let normalizado = estado
      .toUpperCase()
      .normalize("NFD")                      // Quitar acentos
      .replace(/[\u0300-\u036f]/g, "")      // Quitar acentos
      .replace(/[^A-Z\s]/g, "")             // Quitar símbolos
      .replace(/\s+/g, " ")                 // Quitar espacios dobles
      .trim();
      
    // Casos especiales para México - probar múltiples variantes
    if (normalizado === 'ESTADO DE MEXICO' || normalizado === 'MEXICO') {
      // Probar ambas variantes en el catálogo
      return normalizado; // Devolver tal como está para que se pruebe primero
    }
    
    // Quitar palabras comunes después de casos especiales
    const sinPalabrasComunes = normalizado
      .replace(/\b(ESTADO\s+DE|ESTADO|DE)\b/g, "")
      .replace(/\s+/g, " ")
      .trim();
      
    return sinPalabrasComunes;
      
    return normalizado;
  }

  normalizeString(str: string): string {
    return str
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  getPlaces(places: any) { // coordenadas por búsquedas    
    // Limpiar coordenadas anteriores
    this.latitud = null;
    this.longitud = null;
    
    // Asignar nuevas coordenadas desde la búsqueda
    if (places && places.geometry && places.geometry.location) {
      this.latitud = places.geometry.location.lat;
      this.longitud = places.geometry.location.lng;
    }
  }

  getReverseByCordinates(cordinates: any) {
    // Limpiar coordenadas anteriores
    this.latitud = null;
    this.longitud = null;
    
    // Asignar nuevas coordenadas
    if (cordinates && cordinates.lat && cordinates.lng) {
      this.latitud = cordinates.lat;
      this.longitud = cordinates.lng;
    }
  }

  getReverseByAdreess(address: any) {
    console.log('Datos completos del mapa:', JSON.stringify(address, null, 2));
    
    // Verificar el tipo de datos recibidos
    if (address.address_components) {
      // Datos completos de Google Maps - usar estructura de address_components
      this.processGoogleMapsData(address);
    } else if (address.isOpenStreetMap && address.address) {
      // Datos de OpenStreetMap - usar para código postal, municipio y ciudad
      this.processOpenStreetMapData(address);
    }
  }
  
  processGoogleMapsData(address: any) {
    console.log('Procesando datos de Google Maps');
    
    const components = address.address_components;
    
    // Buscar colonia/localidad en Google Maps
    let colonia = '';
    
    // Primero buscar sublocality (colonia)
    const sublocalityComponent = components.find((comp: any) => 
      comp.types.includes('sublocality') || 
      comp.types.includes('sublocality_level_1') ||
      comp.types.includes('neighborhood')
    );
    
    if (sublocalityComponent) {
      colonia = sublocalityComponent.long_name;
    } else {
      // Si no hay sublocality, usar locality (población)
      const localityComponent = components.find((comp: any) => 
        comp.types.includes('locality')
      );
      if (localityComponent) {
        colonia = localityComponent.long_name;
      }
    }
    
    if (colonia) {
      console.log('Colonia procesada de Google Maps:', colonia);
      this.direccionForm.patchValue({
        colonia: colonia
      });
    }
    
    // Buscar código postal
    const postalCodeComponent = components.find((comp: any) => 
      comp.types.includes('postal_code')
    );
    
    if (postalCodeComponent) {
      this.direccionForm.patchValue({
        codigoPostal: postalCodeComponent.long_name
      });
    }
    
    // Buscar número de calle
    const streetNumberComponent = components.find((comp: any) => 
      comp.types.includes('street_number')
    );
    
    const routeComponent = components.find((comp: any) => 
      comp.types.includes('route')
    );
    
    let calleCompleta = '';
    if (routeComponent) {
      calleCompleta = routeComponent.long_name;
      if (streetNumberComponent) {
        calleCompleta += ' ' + streetNumberComponent.long_name;
      }
    }
    
    // Siempre actualizar el campo (vacío si no hay calle válida)
    this.direccionForm.patchValue({
      calleNumero: calleCompleta
    });
    
    console.log('Calle procesada:', calleCompleta || 'Campo limpiado');
    
    // Procesar estado y municipio - solo llamar obtenerMunicipios que internamente maneja el estado
    this.obtenerMunicipios(address);
  }
  
  processOpenStreetMapData(address: any) {
    console.log('Procesando datos de OpenStreetMap para CP, municipio, ciudad e interior');
    
    // Interior - incluir house_number y otros campos de interior
    const interior = address.address.house_number || 
                    address.address.apartment || 
                    address.address.unit || 
                    address.address.suite ||
                    address.address.floor ||
                    address.address.level;
    
    // Siempre actualizar el campo interior (vacío si no hay valor)
    this.direccionForm.patchValue({
      interior: interior || ''
    });
    
    if(interior) {
      console.log('Interior procesado desde OpenStreetMap:', interior);
    } else {
      console.log('No hay interior en OpenStreetMap - campo limpiado');
    }
    
    // Código Postal desde OpenStreetMap
    if(address.address && address.address.postcode){
      this.direccionForm.patchValue({
        codigoPostal: address.address.postcode
      });
      console.log('Código postal desde OSM:', address.address.postcode);
    }

    // Estado/Ciudad - sincronizar con catálogo
    if (address.address && address.address.state) {
      const estadoEncontrado = this.syncAddresSatateWithCatalogs(address);
      if (estadoEncontrado) {
        console.log('Estado encontrado desde OSM:', estadoEncontrado.descripcion);
      }
    }
    
    // Municipio - obtener catálogo y sincronizar
    this.obtenerMunicipios(address);
  }

  processOpenStreetMapDataSelective(address: any) {
    console.log('Procesando datos selectivos de OpenStreetMap (solo interior, estado y municipio)');
    
    // Interior - incluir house_number
    const interior = address.address.house_number || 
                    address.address.apartment || 
                    address.address.unit || 
                    address.address.suite ||
                    address.address.floor ||
                    address.address.level;
    
    // Siempre actualizar el campo interior (vacío si no hay valor)
    this.direccionForm.patchValue({
      interior: interior || ''
    });
    
    if(interior) {
      console.log('Interior procesado desde OpenStreetMap:', interior);
    } else {
      console.log('No hay interior en OpenStreetMap - campo limpiado');
    }

    // Estado y municipio (NO llenar colonia ni código postal para evitar sobrescribir Google)
    this.obtenerMunicipios(address);
  }

  // Método para obtener código postal más preciso usando Google Maps Geocoding
  getPrecisePostalCode(lat: number, lng: number, fallbackCP: string, coloniaActual: string) {
    console.log(`Buscando CP preciso con Google Maps para: ${lat}, ${lng}`);
    
    // Usar Google Maps Geocoding API (más precisa)
    const googleApiKey = environment.apiGoogleMapsKey;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}&language=es&region=mx`;
    
    fetch(geocodeUrl)
      .then(response => response.json())
      .then(data => {
        console.log('Respuesta Google Geocoding:', data);
        
        if (data.status === 'OK' && data.results && data.results.length > 0) {
          const result = data.results[0];
          let cpActualizado = false;
          let coloniaActualizada = false;
          
          // Extraer componentes de la dirección
          const components = result.address_components;
          
          // Buscar código postal
          const postalCodeComponent = components.find((comp: any) => 
            comp.types.includes('postal_code')
          );
          
          if (postalCodeComponent && postalCodeComponent.long_name !== fallbackCP) {
            console.log('CP preciso encontrado:', postalCodeComponent.long_name);
            this.direccionForm.patchValue({
              codigoPostal: postalCodeComponent.long_name
            });
            cpActualizado = true;
          }
          
          // Buscar colonia/localidad - filtrar códigos numéricos
          let coloniaComponent = null;
          
          // Buscar en orden de prioridad, excluyendo códigos numéricos
          const coloniaTypes = [
            ['sublocality', 'sublocality_level_1'],
            ['neighborhood'],
            ['locality']
          ];
          
          for (let types of coloniaTypes) {
            coloniaComponent = components.find((comp: any) => 
              types.some(type => comp.types.includes(type)) &&
              comp.long_name &&
              !/^\d+$/.test(comp.long_name) && // Excluir códigos puramente numéricos
              comp.long_name.length > 2 // Excluir códigos muy cortos
            );
            if (coloniaComponent) break;
          }
          
          if (coloniaComponent && coloniaComponent.long_name !== coloniaActual) {
            console.log('Colonia encontrada:', coloniaComponent.long_name);
            this.direccionForm.patchValue({
              colonia: coloniaComponent.long_name
            });
            coloniaActualizada = true;
          }
          
          // Si se actualizó el CP, buscar más información
          if (cpActualizado) {
            this.getColoniaByCodigoPostal(postalCodeComponent.long_name, coloniaActual);
          } else {
            this.getColoniaByCodigoPostal(fallbackCP, coloniaActual);
          }
          
          if (!cpActualizado && !coloniaActualizada) {
            this.showLocationInfoMessage();
          }
        } else {
          console.log('Google Geocoding no devolvió resultados válidos');
          this.showLocationInfoMessage();
          this.getColoniaByCodigoPostal(fallbackCP, coloniaActual);
        }
      })
      .catch(error => {
        console.log('Error con Google Geocoding:', error);
        this.showLocationInfoMessage();
        this.getColoniaByCodigoPostal(fallbackCP, coloniaActual);
      });
  }

  // Método para mostrar mensaje informativo al usuario
  showLocationInfoMessage() {
    this.snackBar.open('Los datos se llenaron automáticamente. Verifica que sean correctos, especialmente el código postal y la colonia.', 'Entendido', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  // Método para obtener colonia usando código postal
  getColoniaByCodigoPostal(codigoPostal: string, coloniaActual: string) {
    // API gratuita de códigos postales de México
    const cpUrl = `https://api.zippopotam.us/mx/${codigoPostal}`;
    
    fetch(cpUrl)
      .then(response => response.json())
      .then(data => {
        if (data && data.places && data.places.length > 0) {
          // Buscar una colonia/localidad diferente al municipio actual
          const lugar = data.places[0];
          const nuevaColonia = lugar['place name'];
          
          // Solo actualizar si encontramos algo más específico que el municipio
          if (nuevaColonia && nuevaColonia !== coloniaActual && 
              nuevaColonia.toLowerCase() !== lugar.state.toLowerCase()) {
            console.log('Colonia encontrada por CP:', nuevaColonia);
            this.direccionForm.patchValue({
              colonia: nuevaColonia
            });
          }
        }
      })
      .catch(error => {
        console.log('No se pudo obtener información del código postal:', error);
      });
  }

  onMunicipioChange(event: any) {
    const municipioId = event.value;
    this.selectedMunicipio = this.catalogoMunicipios.find(m => m.id === municipioId) || null;
  }

  onCiudadChange(event: any) {
    const id = event.value;
    this.selectedCiudad = this.catalogoCiudades.find(c => c.id === id);
    if (this.selectedCiudad) {
      this.ciudadIdSeleccionada = this.selectedCiudad.id;
      this.ciudadDescripcionSeleccionada = this.selectedCiudad.descripcion;
      this.obtenerMunicipios(this.ciudadIdSeleccionada);
    }
  }

  actualizarDireccion() {
      if (this.direccionForm.invalid) {
        this.snackBar.open('Completa todos los campos obligatorios antes de continuar.', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
    this.direccionForm.markAllAsTouched(); 
    return;
  }

    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';

    if (!token) {
      this.snackBar.open('No autorizado. Por favor inicia sesión.', 'Cerrar', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }

    if (this.idAddress === null || this.idAddress === 0) {
      this.snackBar.open('Dirección inválida para actualizar.', 'Cerrar', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }

    const url = `${this.baseUrl}/address/${cognitoId}/update`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token
    });
    const formValue = this.direccionForm.value;

    let codestate = '';
      if(this.estadoEncontradoId!=null){
        codestate=this.estadoEncontradoId;
      }else{
        codestate= this.ciudadIdSeleccionada;
      }
    
    const body = {
      identifier: {
        tenants: "adff7f6a-e97d-11eb-9a03-0242ac130003",
        app: "PortalAsistencia"
      },
      petition: {
        idAddress: this.idAddress,
        streetNumber: formValue.calleNumero,
        interiorDepartment: formValue.interior,
        colony: formValue.colonia,
        cp: formValue.codigoPostal,
        identifier: formValue.identificador,
        lat: this.latitud ?? null,    
        lng: this.longitud ?? null,   
        codestate: codestate, // "AS", "GR"...
        descriptionEnt: this.ciudadDescripcionSeleccionada, // "AGUASCALIENTES", etc.
        codemun:  this.selectedMunicipio?.id,   //  "00001"
        desscriptionMun: this.selectedMunicipio?.descripcion, //  "AGUASCALIENTES"
      }
    };

    this.http.put(url, body, { headers }).subscribe({
      next: (response: any) => {
        this.snackBar.open('Dirección guardada correctamente', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        const profileDataStr = localStorage.getItem('profileData');
        if (profileDataStr) {
          const profileData = JSON.parse(profileDataStr);
          const addresses = profileData.address || [];

          const index = addresses.findIndex((d: any) => d.idAddress === this.idAddress);
          if (index !== -1) {
            addresses[index] = {
              ...addresses[index],
              streetNumber: formValue.calleNumero,
              interiorDepartament: formValue.interior,
              colony: formValue.colonia,
              cp: formValue.codigoPostal,
              identifier: formValue.identificador,
              state: this.ciudadDescripcionSeleccionada,
              municipality: this.selectedMunicipio?.descripcion,
              codemun: this.selectedMunicipio?.id,
              lat: this.latitud,
              lng: this.longitud
            };
          }

          profileData.address = addresses;
          localStorage.setItem('profileData', JSON.stringify(profileData));
        }

        this.addressService.emitirActualizacion();
        sessionStorage.removeItem('direccionParaEditar');
        this.router.navigate(['/profile-direcciones']);
      },
      error: (err: any) => {
        this.snackBar.open('Error al guardar la dirección', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
        console.error('Error al guardar dirección:', err);
      }
    });
  }

  soloNumeros(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  soloLetras(event: KeyboardEvent): void {
    const char = event.key;
    const regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/;
    if (!regex.test(char)) {
      event.preventDefault();
    }
  }
  
}